import React, { useContext } from "react";
import { observer } from "mobx-react";

import { playerStoreContext } from "lib/player_store";

import { Grid, Slider } from "@material-ui/core";

const SongTimer = observer(() => {
  const store = useContext(playerStoreContext);

  const { seekTime, loading, progress, durationTime } = store;

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item className="pr-2">
        {seekTime}
      </Grid>
      <Grid item xs>
        <Slider
          disabled
          defaultValue={0}
          value={loading ? null : progress}
          id="player-slider"
        />
      </Grid>
      <Grid item className="pl-2">
        {durationTime}
      </Grid>
    </Grid>
  );
});
export default SongTimer;
